module.exports = __webpack_public_path__ + "img/fig15.d1eb8333.jpg";